const IDLE = 0;
const WILL_START = 1;
const STARTING = 2;
const DICTATING = 3;
const STOPPING = 4;

export { DICTATING, IDLE, STARTING, STOPPING, WILL_START };
